import { Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { BaseForm } from '@/mixins/Base.tsx'
import FileTable from './FileTable'
import {
  FormRenderServiceProxy,
  FileInfoVO,
  ResourceServiceProxy,
  ReplaceResourceFileDto,
  FolderServiceProxy,
} from '@/service-proxies/app-v2/dnc.service-proxies'

import { ServiceProxy as ObsFileServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

import ViewDetail from './ViewDetail/index.vue'
const frsp = new FormRenderServiceProxy()
const ofsp = new ObsFileServiceProxy()
const rsp = new ResourceServiceProxy()
const fsp = new FolderServiceProxy()
const CODE = 'DNC_RESOURCE'
import { cloneDeep } from 'lodash'
import { Tree } from 'ant-design-vue'

enum fileTypes {
  programs = 1,
  documents = 2,
}

@Component({
  components: {
    FileTable,
    ViewDetail
  },
})
export default class UpdateForm extends BaseForm {
  @Ref() aTree: Tree
  @Prop() record

  public visible = { uploadMethod: false, fileTree: false, replaceMethod: false }
  public currentfileType = 1
  public treeData: any[] = []
  public originalFiles: any[] = []
  public treeFiles: any[] = []
  public fakeRecord: any = {}
  public replaceInfo: any = {}
  public currentAction = 'new'
  public detailvisible = false
  public detail = {}
  // loading = false

  get isPublished() {
    return this.record.state === 'PUBLISHED'
  }

  get isDrafted() {
    return this.record.state === 'DRAFTED'
  }

  get isDraftedOrPublished() {
    return this.isDrafted || this.isPublished
  }

  @Watch('record', { deep: true, immediate: true })
  updateFakeRecord(val) {
    this.fakeRecord = cloneDeep(val)
    this.loadSchema()
  }

  @Watch('visible.fileTree')
  resetTreeFiles(val) {
    if (val) {
      this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
      this.originalFiles = []
      this.treeFiles = []
    }
  }

  created() {
    this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
  }

  async loadSchema() {
    try {
      const { schema } = await frsp.findFormSchema(CODE)
      for (let key of Object.keys(schema.properties)) {
        if (key.includes('extendContent')) {
          schema.properties[key].default = this.fakeRecord.extendContent[key.replace('extendContent.', '')]
        } else {
          schema.properties[key].default = this.fakeRecord[key]
        }
        if (this.isDraftedOrPublished) {
          schema.properties[key].readOnly = true
        }
        if (key === 'code') {
          schema.properties[key].readOnly = true
        }
      }
      this.schema = schema
    } catch (e) {
      console.log(e.message)
    }
  }

  loadTreeData(treeNode) {
    return new Promise(resolve => {
      if (treeNode.dataRef.children) {
        resolve()
        return
      }
      fsp.folderList(treeNode.dataRef.key, '').then(res => {
        this.originalFiles = [...this.originalFiles, ...res.fileList]
        let files, folders
        files = res.fileList.map(file => ({ title: file.name, key: file.id, isLeaf: true }))
        folders = res.folderList.map(folder => ({ title: folder.name, key: folder.id, checkable: false }))
        treeNode.dataRef.children = [...files, ...folders]
        this.treeData = [...this.treeData]
        resolve()
      })
    })
  }

  // node
  titleNode(text) {
    return (
      <div style="border-left: 4px solid #3a7fbc; color: #3a7fbc; padding-left: 8px; margin-bottom: 16px;">{text}</div>
    )
  }

  uploadNode(text) {
    return (
      <div
        class="add"
        onClick={this.openUploadMethod.bind(this, text === this.$t('page_resource_pool_job_gram') ? 1 : 2)}
      >
        <a-icon type="plus" />
        &nbsp;
        {this.$t('page_resource_pool_add')}
        {text}
      </div>
    )
  }

  // upload start
  openUploadMethod(fileType) {
    this.currentAction = 'new'
    this.currentfileType = fileType
    this.visible.uploadMethod = true
  }

  openTreeUpload() {
    this.visible.uploadMethod = false
    this.visible.fileTree = true
    this.$nextTick(() => {
      const tree = this.aTree.$el
      const firstNode: any = tree.getElementsByClassName('ant-tree-switcher')
      if (firstNode[0]) {
        firstNode[0].click()
      }
    })
  }

  handleTreeUpload() {
    const files = this.originalFiles
      .filter(item => {
        return this.treeFiles.includes(item.id)
      })
      .map(item => {
        return {
          contentLength: item.contentLength,
          contentMd5: item.contentMd5,
          contentType: item.contentType,
          displayName: item.name,
          objectKey: item.objectKey,
          suffix: item.suffix,
          fileType: this.currentfileType,
        } as FileInfoVO
      })
    const realFiles = []
    if (this.currentfileType === 1) {
      for (let f of files) {
        const flag = this.fakeRecord.programs.find(item => item.contentMd5 === f.contentMd5)
        if (!flag) {
          realFiles.push(f)
        } else {
          this.$message.info(this.$t('page_resource_pool_repeat'))
        }
      }
      this.fakeRecord.programs = [...this.fakeRecord.programs, ...realFiles]
    }
    if (this.currentfileType === 2) {
      for (let f of files) {
        const flag = this.fakeRecord.documents.find(item => item.contentMd5 === f.contentMd5)
        if (!flag) {
          realFiles.push(f)
        } else {
          this.$message.info(this.$t('page_resource_pool_repeat'))
        }
      }
      this.fakeRecord.documents = [...this.fakeRecord.documents, ...realFiles]
    }
    this.visible.fileTree = false
  }

  handleFileUpload() {
    this.visible.uploadMethod = false
    const upload = document.createElement('input')
    upload.type = 'file'
    upload.multiple = true
    upload.onchange = async (e: any) => {
      const files: any = e.path[0].files
      files.forEach(async file => {
        const res = await (await ofsp.putFileUsingPOST({fileName:file.name,data:file})).data
        const ossfile = await (await ofsp.statFileUsingGET(res.name)).data

        this.fakeRecord[this.currentfileType === 1 ? 'programs' : 'documents'].push({
            contentLength: ossfile.length.toString(),
            contentMd5: ossfile.hash,
            contentType: ossfile.contentType,
            displayName: file.name,
            objectKey: res.name,
            suffix: file.name.lastIndexOf(".") > 0 ? file.name.substring(file.name.lastIndexOf(".") + 1) : "",
            fileType: this.currentfileType,
          } as FileInfoVO)
      })
    }
    upload.click()
  }
  // upload end

  // replace start
  openReplaceMethod({ record, index }) {
    this.currentAction = 'replace'
    this.replaceInfo = { record, index }
    this.currentfileType = record.fileType
    this.visible.replaceMethod = true
  }

  openTreeReplace() {
    this.visible.replaceMethod = false
    this.visible.fileTree = true
    this.$nextTick(() => {
      const tree = this.aTree.$el
      const firstNode: any = tree.getElementsByClassName('ant-tree-switcher')
      if (firstNode[0]) {
        firstNode[0].click()
      }
    })
  }

  async handleTreeReplace() {
    try {
      this.$emit('update', true)
      const { record, index } = this.replaceInfo
      const files = this.originalFiles
        .filter(item => {
          return this.treeFiles.includes(item.id)
        })
        .map(item => {
          return {
            contentLength: item.contentLength,
            contentMd5: item.contentMd5,
            contentType: item.contentType,
            displayName: item.name,
            objectKey: item.objectKey,
            suffix: item.suffix,
            fileType: this.currentfileType,
          } as FileInfoVO
        })
      if (files.length > 1) {
        this.$message.info(this.$t('page_resource_pool_one'))
        return
      }
      const res = files[0]
      const body = {
        oldFileId: record.id,
        newFile: {
          contentLength: res.contentLength,
          contentMd5: res.contentMd5,
          contentType: res.contentType,
          displayName: res.displayName,
          objectKey: res.objectKey,
          suffix: res.suffix,
          fileType: record.fileType,
        } as FileInfoVO,
        resourceId: this.record.id,
      } as ReplaceResourceFileDto
      await rsp.replaceFile(body)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.$emit('update', false)
      this.$set(this.fakeRecord[fileTypes[this.currentfileType]], index, {
        contentLength: res.contentLength,
        contentMd5: res.contentMd5,
        contentType: res.contentType,
        displayName: res.displayName,
        objectKey: res.objectKey,
        suffix: res.suffix,
        fileType: record.fileType,
      })
      this.$emit('refreshTableData')

      this.visible.fileTree = false
    } catch (e) {
      this.$emit('update', false)
    }
  }

  handleFileReplace() {
    const { record, index } = this.replaceInfo
    this.visible.replaceMethod = false
    const upload = document.createElement('input')
    upload.type = 'file'
    upload.onchange = async (e: any) => {
      try {
        this.$emit('update', true)
        const file: File = e.path[0].files[0]
        const res = await (await ofsp.putFileUsingPOST({fileName:file.name,data:file})).data
        const ossfile = await (await ofsp.statFileUsingGET(res.name)).data

        const fileSuffix = file.name.lastIndexOf(".") > 0 ? file.name.substring(file.name.lastIndexOf(".") + 1) : ""
        const body = {
          oldFileId: record.id,
          newFile: {
            contentLength: ossfile.length.toString(),
            contentMd5: ossfile.hash,
            contentType: ossfile.contentType,
            displayName: file.name,
            objectKey: ossfile.name,
            suffix: fileSuffix,
            fileType: record.fileType,
          } as FileInfoVO,
          resourceId: this.record.id,
        } as ReplaceResourceFileDto
        await rsp.replaceFile(body)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.$emit('update', false)

        this.$set(this.fakeRecord[fileTypes[record.fileType]], index, {
          contentLength: ossfile.length.toString(),
          contentMd5: ossfile.hash,
          contentType: ossfile.contentType,
          displayName: file.name,
          objectKey: ossfile.name,
          suffix: fileSuffix,
          fileType: record.fileType,
        })
        this.$emit('refreshTableData')
      } catch (e) {
        this.$emit('update', false)
      }
    }
    upload.click()
  }
  // replace end

  decideTreeUploadOrReplace() {
    if (this.currentAction === 'new') {
      this.handleTreeUpload()
    }
    if (this.currentAction === 'replace') {
      this.handleTreeReplace()
    }
  }

  handleDelete({ record, index }) {
    this.fakeRecord[record.fileType === 1 ? 'programs' : 'documents'].splice(index, 1)
  }
  openPreview(record){
    this.detail = record
    this.detailvisible = true
  }
  closeDetail(){
    this.detailvisible = false
  }
  render() {
    return (
      <div class="update-form">
        {this.titleNode(this.$t('page_resource_pool_base'))}
        <d-form key={Date.now()} schema={this.schema} cols={2} ref="dForm" />
        <a-row gutter={16}>
          <a-col span={12}>
            {this.titleNode(this.$t('page_resource_pool_job_gram'))}
            <FileTable
              data={this.fakeRecord.programs}
              onDelete={this.handleDelete}
              onReplace={this.openReplaceMethod}
              onPreview={this.openPreview}
              isDraftedOrPublished={this.isDraftedOrPublished}
            />
            {this.isDraftedOrPublished ? null : this.uploadNode(this.$t('page_resource_pool_job_gram'))}
          </a-col>
          <a-col span={12}>
            {this.titleNode(this.$t('page_resource_pool_art'))}
            <FileTable
              data={this.fakeRecord.documents}
              onDelete={this.handleDelete}
              onReplace={this.openReplaceMethod}
              onPreview={this.openPreview}
              isDraftedOrPublished={this.isDraftedOrPublished}
            />
            {this.isDraftedOrPublished ? null : this.uploadNode(this.$t('page_resource_pool_art'))}
          </a-col>
        </a-row>

        <a-modal
          width={320}
          title={null}
          footer={null}
          visible={this.visible.uploadMethod}
          closable={false}
          centered={true}
          maskClosable={false}
        >
          <div style="display: flex; margin: 40px 0">
            <div style="display: flex; flex-direction: column; align-items: center; width: 50%;">
              <a-icon type="file" style="color: #4a90e2; font-size: 40px" onClick={this.openTreeUpload} />
              <span>{this.$t('page_resource_pool_my_doc')}</span>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; width: 50%;">
              <a-icon type="desktop" style="color: #4a90e2; font-size: 40px" onClick={this.handleFileUpload} />
              <span>{this.$t('page_resource_pool_local_doc')}</span>
            </div>
          </div>
          <div style="text-align: center">
            <a-button onClick={() => (this.visible.uploadMethod = false)}>{this.$t('close')}</a-button>
          </div>
        </a-modal>
        <a-modal
          width={320}
          title={null}
          footer={null}
          visible={this.visible.replaceMethod}
          closable={false}
          centered={true}
          maskClosable={false}
        >
          <div style="display: flex; margin: 40px 0">
            <div style="display: flex; flex-direction: column; align-items: center; width: 50%;">
              <a-icon type="file" style="color: #4a90e2; font-size: 40px" onClick={this.openTreeReplace} />
              <span>{this.$t('page_resource_pool_my_doc')}</span>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; width: 50%;">
              <a-icon type="desktop" style="color: #4a90e2; font-size: 40px" onClick={this.handleFileReplace} />
              <span>{this.$t('page_resource_pool_local_doc')}</span>
            </div>
          </div>
          <div style="text-align: center">
            <a-button onClick={() => (this.visible.replaceMethod = false)}>{this.$t('close')}</a-button>
          </div>
        </a-modal>
        <a-modal
          title={null}
          okText={this.$t('page_resource_pool_add')}
          cancelText={this.$t('close')}
          onOk={this.decideTreeUploadOrReplace}
          onCancel={() => (this.visible.fileTree = false)}
          visible={this.visible.fileTree}
          closable={false}
          destroyOnClose={true}
          maskClosable={false}
        >
          <a-tree
            v-model={this.treeFiles}
            ref="aTree"
            checkable
            loadData={this.loadTreeData}
            treeData={this.treeData}
            showLine
          />
        </a-modal>
        <view-detail visible={this.detailvisible} item={this.detail} onClose={this.closeDetail}/>
      </div>
    )
  }
}
